import React from "react";
import { connect } from "react-redux";
import { reduxForm, formValueSelector } from "redux-form";
import XLSX from "xlsx";
import Dropzone from "react-dropzone";
import { formatDate, formatNumber } from "../utility";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import transactionForm from "./TransactionForm";
import MaterialAutocomplete from "./MaterialAutocomplete";
import { FormattedDate, FormattedNumber, FormattedTime } from "react-intl";
import { Transaction } from "../constants/enums";
import * as agent from "../agent";
import MaterialDatePicker from "./MaterialDatePicker";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Preloader from "./Preloader";
import InnerLink from "./InnerLink";
import PrintLink from "./PrintLink";
import TablePaginationActions from "./TablePaginationActions";
import Fade from "@material-ui/core/Fade";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import Paper from "@material-ui/core/Paper";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import IconButton from "@material-ui/core/IconButton";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import InputAdornment from "@material-ui/core/InputAdornment";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import PrimaryDivider from "./PrimaryDivider";
import throttle from "lodash/throttle";
import theme from "../constants/theme";
const { lightGreen, white } = theme.palette;

const TransactionForm = connect((state, props) => {
    const { operations } = props;
    const inputOperation = formValueSelector("transaction-form")(
        state,
        "operation"
    );
    const inputAccount = formValueSelector("transaction-form")(
        state,
        "account"
    );
    const foundedOperation = operations.find(o => o._id === inputOperation);
    const { mustHaveContract, mustHaveCredit, mustHaveDepartment, alias } =
        foundedOperation || {};
    return {
        isAdmin: state.common.user.permissions.includes("forms-full-access"),
        alias,
        inputAccount,
        mustHaveContract,
        mustHaveCredit,
        mustHaveDepartment,
        initialValues: {
            manager: state.common.user.id,
            paymentDate: formatDate(new Date()),
            vat: 0
        }
    };
})(reduxForm({ form: "transaction-form" })(transactionForm));

const CopyTransactionForm = connect((state, props) => {
    const { copiedTransactionId, operations, transactions } = props;
    const foundTransaction = transactions.find(
        t => t._id === copiedTransactionId
    );
    const foundOperation = operations.find(
        o => o._id === foundTransaction.operation._id
    );
    const inputOperation = formValueSelector("copy-transaction-form")(
        state,
        "operation"
    );
    const inputAccount = formValueSelector("copy-transaction-form")(
        state,
        "account"
    );
    const inputOperationSubgroup = formValueSelector("copy-transaction-form")(
        state,
        "operationSubgroup"
    );
    const {
        mustHaveContract,
        mustHaveCredit,
        mustHaveDepartment,
        alias
    } = Object.assign({}, foundOperation, inputOperation);

    return {
        isAdmin: state.common.user.permissions.includes("forms-full-access"),
        copyMode: true,
        alias,
        inputOperationSubgroup,
        inputAccount,
        mustHaveContract,
        mustHaveCredit,
        mustHaveDepartment,
        initialValues: Object.assign(
            {},
            {
                manager: foundTransaction.manager._id,
                department: foundTransaction.department,
                counterparty: (foundTransaction.counterparty || {})._id,
                account: foundTransaction.account._id,
                operation: foundTransaction.operation._id,
                paymentDate: formatDate(new Date(foundTransaction.paymentDate)),
                sum: foundTransaction.sum,
                vat: foundTransaction.vat,
                comment: foundTransaction.comment || ""
            },
            foundTransaction.contract
                ? { contract: foundTransaction.contract._id }
                : {}
        )
    };
})(
    reduxForm({ form: "copy-transaction-form", enableReinitialize: true })(
        transactionForm
    )
);

const ProcessTransactionForm = connect((state, props) => {
    const { editedTransaction, importedAccount, operations, accounts } = props;
    const { counterparty: { _id } = {}, comment, sum } = editedTransaction;
    const inputOperation = formValueSelector("process-transaction-form")(
        state,
        "operation"
    );
    const inputAccount = formValueSelector("process-transaction-form")(
        state,
        "account"
    );
    const foundOperation = operations.find(o => o._id === inputOperation);
    const foundAccount = accounts.find(a => a.number === importedAccount) || {};
    const { mustHaveContract, mustHaveCredit, mustHaveDepartment, alias } =
        foundOperation || {};
    const vatMatch = (comment || "").match(/В том числе НДС (\d\d)\%/i);

    return {
        isAdmin: state.common.user.permissions.includes("forms-full-access"),
        alias,
        inputAccount,
        mustHaveContract,
        mustHaveCredit,
        mustHaveDepartment,
        initialValues: {
            manager: state.common.user.id,
            paymentDate: editedTransaction.date,
            counterparty: _id,
            account: foundAccount._id,
            comment,
            sum,
            vat: vatMatch ? vatMatch[1] : 0
        }
    };
})(reduxForm({ form: "process-transaction-form" })(transactionForm));

class Transactions extends React.Component {
    state = {
        operationsLoaded: false,
        operations: [],
        operationSubgroupsLoaded: false,
        operationSubgroups: [],
        accountsLoaded: false,
        accounts: [],
        managersLoaded: false,
        managers: [],
        counterparties: [],
        transactionsLoaded: false,
        transactions: [],
        totalTransactions: 0,
        currentPage: 0,
        offices: [],
        sortedField: "date",
        searchQuery: "",
        startDate: null,
        endDate: new Date(),
        asc: -1,
        operationFilterCondition: "IN",
        accountFilterCondition: "IN",
        selectedSubgroup: "",
        filteredOperations: [],
        filteredAccounts: [],
        filteredSides: [],
        copiedTransactionId: null,
        showModal: false,
        showCopyModal: false,
        showImportModal: false,
        balanceLoaded: false,
        balance: [],
        fileSelected: false,
        fileLoaded: false,
        fileName: "",
        uploadError: "",
        importedTransactions: [],
        importedAccount: null,
        editedTransaction: {}
    };

    componentDidMount = () => setTimeout(this.fetchData, 200);

    fetchData = () => {
        this.fetchManagers();
        this.fetchOperations();
        this.fetchOperationSubgroups();
        this.fetchAccounts();
        this.fetchTransactions();
        this.fetchBalance();
    };
    fetchManagers = () => {
        agent.User.managers()
            .then(res =>
                this.setState({ managersLoaded: true, managers: res.managers })
            )
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };
    fetchAccounts = () => {
        agent.Account.getAll()
            .then(res => this.setState({ accountsLoaded: true, accounts: res }))
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };
    fetchOperations = () => {
        agent.Operation.getAll()
            .then(res =>
                this.setState({ operationsLoaded: true, operations: res })
            )
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };
    fetchOperationSubgroups = () => {
        agent.OperationSubgroup.getGrouped()
            .then(res =>
                this.setState({
                    operationSubgroupsLoaded: true,
                    operationSubgroups: res
                })
            )
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };
    fetchBalance = () => {
        this.setState({ balanceLoaded: false });
        agent.Transactions.balance()
            .then(res => this.setState({ balance: res, balanceLoaded: true }))
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };
    fetchTransactions = () => {
        this.setState({ transactionsLoaded: false });

        const {
            currentPage,
            filteredOperations,
            filteredSides,
            operationFilterCondition,
            accountFilterCondition,
            filteredAccounts,
            sortedField,
            asc,
            searchQuery = "",
            startDate,
            endDate
        } = this.state;
        let criteria = Object.assign(
            { currentPage, sortedField, asc },
            startDate ? { startDate: startDate.valueOf() } : {},
            endDate ? { endDate: endDate.valueOf() } : {},
            searchQuery.length > 1 ? { searchQuery } : {},
            filteredOperations.length > 0
                ? {
                      filteredOperations: filteredOperations.map(o => o._id),
                      operationFilterCondition
                  }
                : {},
            filteredSides.length > 0 ? { filteredSides } : {},
            filteredAccounts.length > 0
                ? {
                      filteredAccounts: filteredAccounts.map(a => a._id),
                      accountFilterCondition
                  }
                : {}
        );

        agent.Transactions.all(criteria)
            .then(res =>
                this.setState({
                    totalTransactions: res.count,
                    transactions: res.transactions,
                    transactionsLoaded: true
                })
            )
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };
    addTransaction = data => {
        const { transactions, totalTransactions, operations } = this.state;
        const { operation, sum } = data;
        const foundedOperation = operations.find(o => o._id === operation);
        const isTransfer = foundedOperation.alias === "TRANSFER_CREDIT";
        const method = isTransfer
            ? agent.Transactions.transfer
            : agent.Transactions.add;
        method(
            Object.assign({}, data, {
                sum:
                    Number(`${sum}`.replace(/\s/g, ``)) *
                    { DEBIT: 1, CREDIT: -1 }[foundedOperation.side]
            })
        )
            .then(res =>
                this.setState({
                    transactions: [].concat(res).concat(transactions),
                    totalTransactions: totalTransactions + isTransfer ? 2 : 1,
                    showModal: false,
                    showCopyModal: false
                })
            )
            .then(() =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: "Транзакция добавлена", type: "success" }
                })
            )
            .then(() => this.fetchBalance())
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };
    deleteTransaction = id => {
        const { transactions, totalTransactions } = this.state;
        if (
            window.confirm(
                "Вы уверены в необходимости удалить транзакцию? Это повлияет на остатки по счетам"
            )
        ) {
            agent.Transactions.delete(id)
                .then(() =>
                    this.setState({
                        transactions: transactions.filter(t => t._id !== id),
                        totalTransactions: totalTransactions - 1
                    })
                )
                .then(() =>
                    this.props.dispatch({
                        type: MESSAGE_SENDED,
                        payload: { text: "Транзакция удалена", type: "success" }
                    })
                )
                .then(() => this.fetchBalance())
                .catch(e =>
                    this.props.dispatch({
                        type: MESSAGE_SENDED,
                        payload: { text: e.message, type: "error" }
                    })
                );
        }
    };
    selectOperationCondition = e =>
        this.setState({ operationFilterCondition: e.target.value }, () =>
            this.fetchTransactions()
        );
    selectAccountCondition = e =>
        this.setState({ accountFilterCondition: e.target.value }, () =>
            this.fetchTransactions()
        );
    selectOperationToFilter = operation => {
        const { filteredOperations } = this.state;
        this.setState(
            {
                filteredOperations: []
                    .concat(filteredOperations)
                    .concat(operation)
            },
            () => this.fetchTransactions()
        );
    };
    selectAccountToFilter = account => {
        const { filteredAccounts } = this.state;
        this.setState(
            { filteredAccounts: [].concat(filteredAccounts).concat(account) },
            () => this.fetchTransactions()
        );
    };
    selectSubgroup = e => {
        this.setState({ selectedSubgroup: e.target.value });
    };
    deleteFilteredAccount = id => {
        const { filteredAccounts } = this.state;
        this.setState(
            { filteredAccounts: filteredAccounts.filter(a => a._id !== id) },
            () => this.fetchTransactions()
        );
    };
    deleteFilteredOperation = id => {
        const { filteredOperations } = this.state;
        this.setState(
            {
                filteredOperations: filteredOperations.filter(o => o._id !== id)
            },
            () => this.fetchTransactions()
        );
    };
    toggleAccount = _id => {
        const { filteredAccounts } = this.state;
        this.setState(
            {
                currentPage: 0,
                filteredAccounts: filteredAccounts.includes(_id)
                    ? filteredAccounts.filter(a => a !== _id)
                    : filteredAccounts.concat(_id)
            },
            () => this.fetchTransactions()
        );
    };
    toggleOperationSide = side => {
        const { filteredSides } = this.state;
        this.setState(
            {
                currentPage: 0,
                filteredSides: filteredSides.includes(side)
                    ? filteredSides.filter(s => s !== side)
                    : filteredSides.concat(side)
            },
            () => this.fetchTransactions()
        );
    };
    handleClick = e => {
        e.preventDefault();
        this.setState({ showModal: true });
    };
    handleClose = () => this.setState({ showModal: false });
    sortTable = f => {
        const { sortedField, asc } = this.state;
        this.setState(
            { sortedField: f, asc: sortedField === f ? -1 * asc : asc },
            () => this.fetchTransactions()
        );
    };
    onUpload = files => {
        this.setState({
            fileSelected: true,
            fileLoaded: false,
            uploadError: ""
        });
        const f = files[0];
        if (f.type !== "application/vnd.ms-excel") {
            this.setState({
                uploadError: "Неверный формат файла",
                fileSelected: false
            });
            return;
        }
        const reader = new FileReader();
        reader.readAsArrayBuffer(f);
        reader.onerror = e => {
            reader.abort();
            this.setState({
                uploadError: "Ошибка при обработке файла",
                fileSelected: false
            });
            return;
        };
        reader.onload = async e => {
            this.setState({ fileLoaded: true, fileName: f.name });
            const workbook = XLSX.read(reader.result, { type: "array" });
            const { Sheets: { Sheet1 = {} } = {} } = workbook;
            const keys = Object.keys(Sheet1);
            const counterparties = await agent.Counterparty.getAll()
                .then(res => {
                    this.setState({ counterparties: res });
                    return res;
                })
                .catch(e =>
                    this.props.dispatch({
                        type: MESSAGE_SENDED,
                        payload: { text: e.message, type: "error" }
                    })
                );

            const importedTransactions = keys
                .filter(
                    k =>
                        k.startsWith("A") &&
                        /^\d\d\.\d\d\.\d\d\d\d$/.test(Sheet1[k].v || "")
                )
                .map(k => {
                    let n = k.slice(1);
                    let inn = (Sheet1[`G${n}`] || {}).v;
                    let counterparty = counterparties.find(
                        c => c.inn && c.inn === inn
                    );
                    return {
                        imported: {
                            date: Sheet1[`A${n}`].v,
                            counterparty: counterparty ? counterparty : void 0,
                            sum:
                                (Sheet1[`I${n}`] || {}).v ||
                                (Sheet1[`J${n}`] || {}).v,
                            comment: (Sheet1[`K${n}`] || {}).v
                        }
                    };
                });
            this.setState({
                importedTransactions,
                importedAccount: (Sheet1["B5"] || {}).v
            });
        };
    };
    throttledSearchTransactions = throttle(() => this.fetchTransactions(), 500);
    clearSearch = () => {
        this.setState({ searchQuery: "" }, () => this.fetchTransactions());
    };
    searchTransactions = e => {
        const query = e.target.value;
        this.setState({ searchQuery: query }, this.throttledSearchTransactions);
    };
    handleCopyOpen = (e, id) => {
        e.preventDefault();
        this.setState({ showCopyModal: true, copiedTransactionId: id });
    };
    handleCopyClose = () => this.setState({ showCopyModal: false });
    handleImportOpen = (e, id) => {
        e.preventDefault();
        this.setState({ showImportModal: true });
    };
    handleImportClose = () =>
        this.setState({ showImportModal: false, editedTransaction: null });
    removeImportedTransaction = index => {
        const { importedTransactions } = this.state;
        if (
            window.confirm(
                "Подтвердите удаление этой транзакции из списка импортируемых"
            )
        ) {
            this.setState({
                importedTransactions: importedTransactions.filter(
                    (_, i) => i !== index
                )
            });
        }
    };
    loadTransaction = t => {
        this.setState({ editedTransaction: null }, () =>
            this.setState({ editedTransaction: t })
        );
    };
    processTransaction = data => {
        const {
            importedTransactions,
            editedTransaction,
            operations
        } = this.state;
        const { operation } = data;
        const foundOperation = operations.find(o => o._id === operation);
        this.setState(
            {
                importedTransactions: importedTransactions.map((t, i) => {
                    return i === editedTransaction.index
                        ? Object.assign(
                              {},
                              t,
                              { processed: true },
                              {
                                  edited: Object.assign({}, data, {
                                      sum:
                                          Number(
                                              `${data.sum}`.replace(/\s/g, ``)
                                          ) *
                                          { DEBIT: 1, CREDIT: -1 }[
                                              foundOperation.side
                                          ]
                                  })
                              }
                          )
                        : t;
                }),
                editedTransaction: null
            },
            () => this.setState({ editedTransaction: {} })
        );
    };
    importTransactions = () => {
        const { importedTransactions } = this.state;
        agent.Transactions.import(importedTransactions)
            .then(() =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: {
                        text: "Транзакции импортированы",
                        type: "success"
                    }
                })
            )
            .then(() => {
                this.fetchTransactions();
                this.fetchBalance();
                this.clearImport();
                this.handleImportClose();
            })
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };
    clearImport = () =>
        this.setState({
            importedTransactions: [],
            editedTransaction: {},
            fileLoaded: false,
            fileName: "",
            fileSelected: false
        });
    turnPage = (e, p) =>
        this.setState({ currentPage: p }, () => this.fetchTransactions());
    onStartDateChange = date =>
        this.setState({ startDate: new Date(date) }, () =>
            this.fetchTransactions()
        );
    onEndDateChange = date =>
        this.setState({ endDate: new Date(date) }, () =>
            this.fetchTransactions()
        );

    render() {
        const {
            managers,
            managersLoaded,
            transactionsLoaded,
            transactions,
            totalTransactions,
            accounts,
            accountsLoaded,
            counterparties,
            operations,
            operationsLoaded,
            operationSubgroups,
            currentPage,
            sortedField,
            asc,
            filteredOperations,
            filteredSides,
            filteredAccounts,
            searchQuery,
            startDate,
            endDate,
            showModal,
            showCopyModal,
            showImportModal,
            copiedTransactionId,
            selectedSubgroup,
            operationFilterCondition,
            accountFilterCondition,
            balance,
            balanceLoaded,
            fileSelected,
            fileLoaded,
            fileName,
            uploadError,
            importedTransactions,
            importedAccount,
            editedTransaction
        } = this.state;
        let dropzoneRef;
        const { userId, permissions, godmode } = this.props;

        const thead = Object.assign(
            {},
            {
                date: "Дата",
                paymentDate: "Оплата",
                manager: "Исполнитель",
                department: "Офис",
                operation: "Статья ДДС",
                counterparty: "Контрагент",
                contract: "Договор / Кредит",
                account: "Учетный счет",
                sum: "Сумма",
                period: "Период",
                overdue: "Просрочен",
                comment: "Комментарий",
                "": ""
            },
            permissions.includes("bookkeeping") && godmode ? { del: "" } : {}
        );
        const importSubmitDisable = importedTransactions.some(
            t => !t.processed
        );
        return (
            <Fade in={true}>
                <React.Fragment>
                    {balanceLoaded ? (
                        <Table padding="checkbox" className="mb20">
                            <TableHead>
                                <TableRow>
                                    {balance.map(({ _id }, i) => (
                                        <TableCell key={i}>{_id}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    {balance.map(({ sum }, j) => (
                                        <TableCell key={j}>
                                            <FormattedNumber
                                                value={sum}
                                                style={`currency`}
                                                currency="RUB"
                                                minimumFractionDigits={0}
                                            />
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableBody>
                        </Table>
                    ) : (
                        <Preloader />
                    )}
                    <PrimaryDivider />
                    <Grid container justify="flex-start" spacing={16}>
                        <Grid item xs>
                            <Grid container justify="center" spacing={8}>
                                <Grid item>
                                    <Grid
                                        container
                                        alignItems="center"
                                        justify="flex-start"
                                        spacing={8}
                                    >
                                        <Grid item>
                                            <PrintLink
                                                href={agent.src.printTransactionReport(
                                                    Object.assign(
                                                        { sortedField, asc },
                                                        startDate
                                                            ? {
                                                                  startDate: startDate.valueOf()
                                                              }
                                                            : {},
                                                        endDate
                                                            ? {
                                                                  endDate: endDate.valueOf()
                                                              }
                                                            : {},
                                                        searchQuery.length > 1
                                                            ? { searchQuery }
                                                            : {},
                                                        filteredOperations.length >
                                                            0
                                                            ? {
                                                                  filteredOperations: filteredOperations.map(
                                                                      o => o._id
                                                                  ),
                                                                  operationFilterCondition
                                                              }
                                                            : {},
                                                        filteredSides.length > 0
                                                            ? { filteredSides }
                                                            : {},
                                                        filteredAccounts.length >
                                                            0
                                                            ? {
                                                                  filteredAccounts: filteredAccounts.map(
                                                                      a => a._id
                                                                  ),
                                                                  accountFilterCondition
                                                              }
                                                            : {}
                                                    )
                                                )}
                                                label="Скачать"
                                            />
                                        </Grid>
                                        <Grid item>
                                            <Button
                                                onClick={this.handleClick}
                                                color="primary"
                                                variant="contained"
                                            >
                                                Добавить
                                            </Button>
                                            {showModal && (
                                                <Dialog
                                                    maxWidth={false}
                                                    open={showModal}
                                                    classes={{
                                                        paperScrollPaper:
                                                            "overflow-visible"
                                                    }}
                                                    onClose={this.handleClose}
                                                >
                                                    <Paper className="common-paper">
                                                        <div className="wide-column">
                                                            <TransactionForm
                                                                adminMode={true}
                                                                managers={
                                                                    managers
                                                                }
                                                                managersLoaded={
                                                                    managersLoaded
                                                                }
                                                                accounts={
                                                                    accounts
                                                                }
                                                                accountsLoaded={
                                                                    accountsLoaded
                                                                }
                                                                operations={
                                                                    operations
                                                                }
                                                                operationsLoaded={
                                                                    operationsLoaded
                                                                }
                                                                operationSubgroups={
                                                                    operationSubgroups
                                                                }
                                                                selectSubgroup={
                                                                    this
                                                                        .selectSubgroup
                                                                }
                                                                selectedSubgroup={
                                                                    selectedSubgroup
                                                                }
                                                                addTransaction={
                                                                    this
                                                                        .addTransaction
                                                                }
                                                            />
                                                        </div>
                                                    </Paper>
                                                </Dialog>
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <Button
                                                onClick={this.handleImportOpen}
                                                color="primary"
                                                variant="contained"
                                            >
                                                Импортировать
                                            </Button>
                                            {showImportModal && (
                                                <Dialog
                                                    maxWidth={false}
                                                    open={showImportModal}
                                                    onClose={
                                                        this.handleImportClose
                                                    }
                                                >
                                                    <Paper
                                                        className="common-paper"
                                                        style={{
                                                            position: "relative"
                                                        }}
                                                    >
                                                        <Typography
                                                            align="center"
                                                            variant="h5"
                                                        >
                                                            Импорт транзакций
                                                        </Typography>
                                                        <Dropzone
                                                            ref={node => {
                                                                dropzoneRef = node;
                                                            }}
                                                            className="hidden-dropzone"
                                                            onDrop={files =>
                                                                this.onUpload(
                                                                    files
                                                                )
                                                            }
                                                        />
                                                        <Grid
                                                            container
                                                            alignItems="center"
                                                            justify="flex-start"
                                                            spacing={16}
                                                        >
                                                            <Grid item>
                                                                <Button
                                                                    disabled={
                                                                        fileSelected &&
                                                                        !fileLoaded
                                                                    }
                                                                    color="primary"
                                                                    onClick={() => {
                                                                        dropzoneRef.open();
                                                                    }}
                                                                    variant="contained"
                                                                >
                                                                    {fileSelected
                                                                        ? fileLoaded
                                                                            ? "Выбрать другой файл"
                                                                            : "Обработка файла..."
                                                                        : "Выберите файл"}
                                                                </Button>
                                                            </Grid>
                                                            <Grid item>
                                                                {uploadError && (
                                                                    <Typography>
                                                                        {
                                                                            uploadError
                                                                        }
                                                                    </Typography>
                                                                )}
                                                                {fileLoaded && (
                                                                    <Typography>
                                                                        {
                                                                            fileName
                                                                        }
                                                                    </Typography>
                                                                )}
                                                            </Grid>
                                                            <Grid item>
                                                                {fileLoaded && (
                                                                    <IconButton
                                                                        onClick={
                                                                            this
                                                                                .clearImport
                                                                        }
                                                                    >
                                                                        <HighlightOffIcon />
                                                                    </IconButton>
                                                                )}
                                                            </Grid>
                                                        </Grid>
                                                        <Grid
                                                            container
                                                            justify="center"
                                                            spacing={16}
                                                            className="m20"
                                                        >
                                                            <Grid
                                                                item
                                                                className="common-column"
                                                            >
                                                                {importedTransactions.length >
                                                                    0 &&
                                                                    fileLoaded &&
                                                                    editedTransaction && (
                                                                        <ProcessTransactionForm
                                                                            adminMode={
                                                                                true
                                                                            }
                                                                            importMode={
                                                                                true
                                                                            }
                                                                            managers={
                                                                                managers
                                                                            }
                                                                            managersLoaded={
                                                                                managersLoaded
                                                                            }
                                                                            accounts={
                                                                                accounts
                                                                            }
                                                                            accountsLoaded={
                                                                                accountsLoaded
                                                                            }
                                                                            operations={
                                                                                operations
                                                                            }
                                                                            operationsLoaded={
                                                                                operationsLoaded
                                                                            }
                                                                            operationSubgroups={
                                                                                operationSubgroups
                                                                            }
                                                                            selectSubgroup={
                                                                                this
                                                                                    .selectSubgroup
                                                                            }
                                                                            selectedSubgroup={
                                                                                selectedSubgroup
                                                                            }
                                                                            editedTransaction={
                                                                                editedTransaction
                                                                            }
                                                                            importedAccount={
                                                                                importedAccount
                                                                            }
                                                                            addTransaction={
                                                                                this
                                                                                    .processTransaction
                                                                            }
                                                                        />
                                                                    )}
                                                            </Grid>
                                                            <Grid
                                                                item
                                                                className="maxwide-column"
                                                            >
                                                                {importedTransactions.length >
                                                                0 ? (
                                                                    <React.Fragment>
                                                                        <Table
                                                                            padding="checkbox"
                                                                            className="mb20"
                                                                        >
                                                                            <TableHead>
                                                                                <TableRow>
                                                                                    <TableCell>
                                                                                        Дата
                                                                                    </TableCell>
                                                                                    <TableCell>
                                                                                        Офис
                                                                                    </TableCell>
                                                                                    <TableCell>
                                                                                        Статья
                                                                                        ДДС
                                                                                    </TableCell>
                                                                                    <TableCell>
                                                                                        Контрагент
                                                                                    </TableCell>
                                                                                    <TableCell>
                                                                                        Сумма
                                                                                    </TableCell>
                                                                                    <TableCell>
                                                                                        Комментарий
                                                                                    </TableCell>
                                                                                    <TableCell>
                                                                                        &nbsp;
                                                                                    </TableCell>
                                                                                    <TableCell>
                                                                                        &nbsp;
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {importedTransactions.map(
                                                                                    (
                                                                                        {
                                                                                            imported = {},
                                                                                            edited = {},
                                                                                            processed = false
                                                                                        },
                                                                                        i
                                                                                    ) => {
                                                                                        const foundOperation = operations.find(
                                                                                            o =>
                                                                                                o._id ===
                                                                                                edited.operation
                                                                                        );
                                                                                        const foundCounterparty = counterparties.find(
                                                                                            c =>
                                                                                                c._id ===
                                                                                                edited.counterparty
                                                                                        );
                                                                                        return (
                                                                                            <TableRow
                                                                                                style={
                                                                                                    processed
                                                                                                        ? lightGreen
                                                                                                        : white
                                                                                                }
                                                                                                key={
                                                                                                    i
                                                                                                }
                                                                                            >
                                                                                                <TableCell>
                                                                                                    {processed
                                                                                                        ? edited.paymentDate
                                                                                                        : imported.date}
                                                                                                </TableCell>
                                                                                                <TableCell>
                                                                                                    {processed
                                                                                                        ? Transaction
                                                                                                              .Departments[
                                                                                                              edited
                                                                                                                  .department
                                                                                                          ] ||
                                                                                                          "—"
                                                                                                        : "—"}
                                                                                                </TableCell>
                                                                                                <TableCell>
                                                                                                    {processed
                                                                                                        ? foundOperation.name
                                                                                                        : "—"}
                                                                                                </TableCell>
                                                                                                <TableCell>
                                                                                                    {processed
                                                                                                        ? foundCounterparty
                                                                                                            ? foundCounterparty.name
                                                                                                            : "—"
                                                                                                        : imported.counterparty
                                                                                                        ? imported
                                                                                                              .counterparty
                                                                                                              .name
                                                                                                        : "—"}
                                                                                                </TableCell>
                                                                                                <TableCell>
                                                                                                    {processed
                                                                                                        ? edited.sum
                                                                                                        : imported.sum}
                                                                                                </TableCell>
                                                                                                <TableCell>
                                                                                                    {processed
                                                                                                        ? edited.comment
                                                                                                        : imported.comment}
                                                                                                </TableCell>
                                                                                                <TableCell>
                                                                                                    <IconButton
                                                                                                        onClick={() =>
                                                                                                            this.loadTransaction(
                                                                                                                {
                                                                                                                    index: i,
                                                                                                                    ...imported
                                                                                                                }
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        <EditIcon />
                                                                                                    </IconButton>
                                                                                                </TableCell>
                                                                                                <TableCell>
                                                                                                    <IconButton
                                                                                                        onClick={() =>
                                                                                                            this.removeImportedTransaction(
                                                                                                                i
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        <DeleteIcon />
                                                                                                    </IconButton>
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                        );
                                                                                    }
                                                                                )}
                                                                            </TableBody>
                                                                        </Table>
                                                                        <Button
                                                                            color="primary"
                                                                            onClick={
                                                                                this
                                                                                    .importTransactions
                                                                            }
                                                                            disabled={
                                                                                importSubmitDisable
                                                                            }
                                                                            variant="contained"
                                                                        >
                                                                            Импортировать
                                                                        </Button>
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <Typography>
                                                                        {fileLoaded
                                                                            ? "Транзакций не найдено"
                                                                            : ""}
                                                                    </Typography>
                                                                )}
                                                            </Grid>
                                                        </Grid>
                                                    </Paper>
                                                </Dialog>
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <MaterialDatePicker
                                                label="Начало периода"
                                                value={startDate}
                                                onChange={
                                                    this.onStartDateChange
                                                }
                                            />
                                        </Grid>
                                        <Grid item>
                                            <MaterialDatePicker
                                                label="Конец периода"
                                                value={endDate}
                                                onChange={this.onEndDateChange}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid
                                    item
                                    container
                                    alignItems="center"
                                    justify="center"
                                    spacing={8}
                                    xs
                                >
                                    <Grid item>
                                        <Button
                                            variant={
                                                filteredSides.includes("DEBIT")
                                                    ? "outlined"
                                                    : "contained"
                                            }
                                            onClick={() =>
                                                this.toggleOperationSide(
                                                    "DEBIT"
                                                )
                                            }
                                        >
                                            Приход
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            variant={
                                                filteredSides.includes("CREDIT")
                                                    ? "outlined"
                                                    : "contained"
                                            }
                                            onClick={() =>
                                                this.toggleOperationSide(
                                                    "CREDIT"
                                                )
                                            }
                                        >
                                            Расход
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Grid item style={{ width: 250 }}>
                                    <TextField
                                        label="Поиск"
                                        helperText="Введите фамилию клиента или сумму транзакции"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        FormHelperTextProps={{
                                            classes: {
                                                root: "input-double-error"
                                            }
                                        }}
                                        onChange={this.searchTransactions}
                                        value={searchQuery}
                                        InputProps={
                                            searchQuery.length > 0
                                                ? {
                                                      endAdornment: (
                                                          <InputAdornment position="end">
                                                              <IconButton
                                                                  onClick={
                                                                      this
                                                                          .clearSearch
                                                                  }
                                                              >
                                                                  <HighlightOffIcon />
                                                              </IconButton>
                                                          </InputAdornment>
                                                      )
                                                  }
                                                : {}
                                        }
                                        variant="outlined"
                                        padding="dense"
                                        margin="dense"
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                justify="flex-start"
                                alignItems="center"
                                spacing={8}
                            >
                                <Grid item style={{ width: 220 }}>
                                    <TextField
                                        label="Условие"
                                        margin="dense"
                                        select
                                        variant="outlined"
                                        onChange={this.selectAccountCondition}
                                        value={accountFilterCondition}
                                        fullWidth
                                    >
                                        <MenuItem value="NOTIN">
                                            Выбрать все кроме...
                                        </MenuItem>
                                        <MenuItem value="IN">
                                            Выбрать только...
                                        </MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item style={{ width: 220 }}>
                                    <MaterialAutocomplete
                                        label="Учетный счет"
                                        margin="dense"
                                        variant="outlined"
                                        formatTextValue={o =>
                                            `${(o || {}).name}`
                                        }
                                        suggestionsPreloaded={true}
                                        preloadedSuggestions={accounts}
                                        getSuggestionsMethod={(s, input) =>
                                            s.name
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                        onChange={this.selectAccountToFilter}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs>
                                    {filteredAccounts.map(
                                        ({ _id, name }, i) => (
                                            <Chip
                                                icon={<DeleteIcon />}
                                                onClick={() =>
                                                    this.deleteFilteredAccount(
                                                        _id
                                                    )
                                                }
                                                label={name}
                                            />
                                        )
                                    )}
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                justify="flex-start"
                                alignItems="center"
                                spacing={8}
                            >
                                <Grid item style={{ width: 220 }}>
                                    <TextField
                                        label="Условие"
                                        margin="dense"
                                        select
                                        variant="outlined"
                                        onChange={this.selectOperationCondition}
                                        value={operationFilterCondition}
                                        fullWidth
                                    >
                                        <MenuItem value="NOTIN">
                                            Выбрать все кроме...
                                        </MenuItem>
                                        <MenuItem value="IN">
                                            Выбрать только...
                                        </MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item style={{ width: 220 }}>
                                    <MaterialAutocomplete
                                        label="Статья ДДС"
                                        margin="dense"
                                        variant="outlined"
                                        formatTextValue={o =>
                                            `${(o || {}).name}`
                                        }
                                        suggestionsPreloaded={true}
                                        preloadedSuggestions={operations}
                                        getSuggestionsMethod={(s, input) =>
                                            s.name
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                        onChange={this.selectOperationToFilter}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs>
                                    {filteredOperations.map(
                                        ({ _id, name }, i) => (
                                            <Chip
                                                icon={<DeleteIcon />}
                                                onClick={() =>
                                                    this.deleteFilteredOperation(
                                                        _id
                                                    )
                                                }
                                                label={name}
                                            />
                                        )
                                    )}
                                </Grid>
                            </Grid>
                            {transactionsLoaded ? (
                                transactions.length > 0 ? (
                                    <Fade in={transactionsLoaded}>
                                        <Table padding="none">
                                            <TableHead>
                                                <TableRow>
                                                    {Object.keys(thead).map(
                                                        (th, i) => {
                                                            return (
                                                                <TableCell
                                                                    key={i}
                                                                >
                                                                    <TableSortLabel
                                                                        active={
                                                                            sortedField ===
                                                                            th
                                                                        }
                                                                        direction={
                                                                            asc ===
                                                                            1
                                                                                ? "asc"
                                                                                : "desc"
                                                                        }
                                                                        onClick={() =>
                                                                            this.sortTable(
                                                                                th
                                                                            )
                                                                        }
                                                                    >
                                                                        {
                                                                            thead[
                                                                                th
                                                                            ]
                                                                        }
                                                                    </TableSortLabel>
                                                                </TableCell>
                                                            );
                                                        }
                                                    )}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {transactions.map(
                                                    (
                                                        {
                                                            _id,
                                                            date,
                                                            paymentDate,
                                                            manager = {},
                                                            operation = {},
                                                            account = {},
                                                            contract,
                                                            credit,
                                                            counterparty,
                                                            department,
                                                            sum,
                                                            comment,
                                                            overdue,
                                                            period = {}
                                                        },
                                                        i
                                                    ) => {
                                                        const {
                                                            client,
                                                            car,
                                                            clientDetails: {
                                                                lastname = "",
                                                                firstname = "",
                                                                patronymic = ""
                                                            } = {},
                                                            creationDate
                                                        } = contract || {};
                                                        const {
                                                            date: creditDate,
                                                            number,
                                                            _id: creditId
                                                        } = credit || {};
                                                        const [
                                                            managerLastname
                                                        ] = (
                                                            (manager || {})
                                                                .fullname || ""
                                                        ).split(" ");
                                                        const cDate = new Date(
                                                            creationDate
                                                        );
                                                        const srcText = formatNumber(
                                                            cDate,
                                                            {
                                                                lastname,
                                                                firstname,
                                                                patronymic
                                                            }
                                                        );

                                                        return (
                                                            <TableRow key={i}>
                                                                <TableCell>
                                                                    <FormattedDate
                                                                        value={
                                                                            date
                                                                        }
                                                                        day="numeric"
                                                                        month="numeric"
                                                                        year="numeric"
                                                                    />
                                                                    <br />
                                                                    <FormattedTime
                                                                        value={
                                                                            date
                                                                        }
                                                                        hour="numeric"
                                                                        minute="numeric"
                                                                        second="numeric"
                                                                    />
                                                                </TableCell>
                                                                <TableCell padding="checkbox">
                                                                    <FormattedDate
                                                                        value={
                                                                            paymentDate
                                                                        }
                                                                        day="numeric"
                                                                        month="numeric"
                                                                        year="numeric"
                                                                    />
                                                                    <br />
                                                                    <FormattedTime
                                                                        value={
                                                                            paymentDate
                                                                        }
                                                                        hour="numeric"
                                                                        minute="numeric"
                                                                        second="numeric"
                                                                    />
                                                                </TableCell>
                                                                <TableCell>
                                                                    <InnerLink
                                                                        href={`/user/${
                                                                            (
                                                                                manager ||
                                                                                {}
                                                                            )
                                                                                ._id
                                                                        }`}
                                                                        target="_blank"
                                                                        label={`${managerLastname}`}
                                                                    />
                                                                </TableCell>
                                                                <TableCell>
                                                                    {Transaction
                                                                        .Departments[
                                                                        department
                                                                    ] || "—"}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {
                                                                        operation.name
                                                                    }
                                                                </TableCell>
                                                                <TableCell padding="checkbox">
                                                                    {contract
                                                                        ? `${lastname} ${firstname} ${patronymic}`.toUpperCase()
                                                                        : counterparty
                                                                        ? (
                                                                              counterparty ||
                                                                              {}
                                                                          ).name
                                                                        : "—"}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {contract ? (
                                                                        <InnerLink
                                                                            href={`/client/${client}/car/${car}`}
                                                                            target="_blank"
                                                                            label={`Договор №${srcText} от ${formatDate(
                                                                                new Date(
                                                                                    creationDate
                                                                                )
                                                                            )}`}
                                                                        />
                                                                    ) : credit ? (
                                                                        <InnerLink
                                                                            href={`/credit/${creditId}`}
                                                                            target="_blank"
                                                                            label={`Кредит №${number} от ${formatDate(
                                                                                new Date(
                                                                                    creditDate
                                                                                )
                                                                            )}`}
                                                                        />
                                                                    ) : (
                                                                        "—"
                                                                    )}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {
                                                                        account.name
                                                                    }
                                                                </TableCell>
                                                                <TableCell padding="checkbox">
                                                                    <FormattedNumber
                                                                        value={
                                                                            sum
                                                                        }
                                                                        style={`currency`}
                                                                        currency="RUB"
                                                                        minimumFractionDigits={
                                                                            Number.isInteger(
                                                                                parseFloat(
                                                                                    sum
                                                                                )
                                                                            )
                                                                                ? 0
                                                                                : 2
                                                                        }
                                                                    />
                                                                </TableCell>
                                                                <TableCell>
                                                                    {(
                                                                        operation.alias ||
                                                                        ""
                                                                    ).startsWith(
                                                                        "CONTRACT_PROLONGATION"
                                                                    )
                                                                        ? `Оплата процентов за период с ${formatDate(
                                                                              new Date(
                                                                                  period.date
                                                                              )
                                                                          )} по ${formatDate(
                                                                              new Date(
                                                                                  +new Date(
                                                                                      period.date
                                                                                  ) +
                                                                                      period.duration *
                                                                                          24 *
                                                                                          60 *
                                                                                          60 *
                                                                                          1000
                                                                              )
                                                                          )}`
                                                                        : ""}
                                                                </TableCell>
                                                                <TableCell padding="checkbox">
                                                                    {overdue}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {comment}
                                                                </TableCell>
                                                                <TableCell>
                                                                    <IconButton
                                                                        onClick={e =>
                                                                            this.handleCopyOpen(
                                                                                e,
                                                                                _id
                                                                            )
                                                                        }
                                                                    >
                                                                        {operation.editable ? (
                                                                            <FileCopyIcon fontSize="small" />
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </IconButton>
                                                                </TableCell>
                                                                {[
                                                                    "5a1192d4005e2959d65aa00c",
                                                                    "5a113f9f56455319aa5fcfab"
                                                                ].includes(
                                                                    userId
                                                                ) &&
                                                                    godmode && (
                                                                        <TableCell>
                                                                            <IconButton
                                                                                onClick={() =>
                                                                                    this.deleteTransaction(
                                                                                        _id
                                                                                    )
                                                                                }
                                                                            >
                                                                                <DeleteIcon fontSize="small" />
                                                                            </IconButton>
                                                                        </TableCell>
                                                                    )}
                                                            </TableRow>
                                                        );
                                                    }
                                                )}
                                            </TableBody>
                                            <TableFooter>
                                                <TableRow>
                                                    <TableCell colSpan={20}>
                                                        <Grid
                                                            container
                                                            justify="center"
                                                        >
                                                            <TablePagination
                                                                count={
                                                                    totalTransactions
                                                                }
                                                                labelDisplayedRows={({
                                                                    from,
                                                                    to,
                                                                    count
                                                                }) =>
                                                                    `${from}-${to} из ${count}`
                                                                }
                                                                rowsPerPage={20}
                                                                rowsPerPageOptions={[]}
                                                                page={
                                                                    currentPage
                                                                }
                                                                onChangePage={
                                                                    this
                                                                        .turnPage
                                                                }
                                                                ActionsComponent={
                                                                    TablePaginationActions
                                                                }
                                                            />
                                                        </Grid>
                                                    </TableCell>
                                                </TableRow>
                                            </TableFooter>
                                        </Table>
                                    </Fade>
                                ) : (
                                    <Typography>
                                        Транзакций не найдено
                                    </Typography>
                                )
                            ) : (
                                <Preloader />
                            )}
                        </Grid>
                    </Grid>
                    {showCopyModal && (
                        <Dialog
                            maxWidth={false}
                            open={showCopyModal}
                            onClose={this.handleCopyClose}
                        >
                            <Paper className="common-paper">
                                <div className="common-column">
                                    <CopyTransactionForm
                                        adminMode={true}
                                        managers={managers}
                                        managersLoaded={managersLoaded}
                                        accounts={accounts}
                                        accountsLoaded={accountsLoaded}
                                        operations={operations}
                                        operationsLoaded={operationsLoaded}
                                        operationSubgroups={operationSubgroups}
                                        selectSubgroup={this.selectSubgroup}
                                        selectedSubgroup={selectedSubgroup}
                                        copiedTransactionId={
                                            copiedTransactionId
                                        }
                                        transactions={transactions}
                                        addTransaction={this.addTransaction}
                                    />
                                </div>
                            </Paper>
                        </Dialog>
                    )}
                </React.Fragment>
            </Fade>
        );
    }
}

export default connect(
    state => ({
        userId: state.common.user.id,
        permissions: state.common.user.permissions,
        godmode: (window.location.search || "").split("?").includes("root")
    }),
    null
)(Transactions);



// WEBPACK FOOTER //
// ./src/components/Transactions.js